import { ChangeDetectionStrategy, Component, inject, input } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { MatIcon, MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-tenzu-front-portal-left-panel",
  imports: [TranslocoDirective, MatIcon],
  template: `
    <ng-container *transloco="let t">
      <div class="h-[200px]">
        @if (priceAmount()) {
          <mat-icon
            class="icon-full"
            svgIcon="heart-animated"
            [attr.aria-description]="t('portal.modal.left_panel.tenzu_love_aria_description')"
          ></mat-icon>
        } @else {
          <mat-icon
            class="icon-full"
            svgIcon="sad-animated"
            [attr.aria-description]="t('portal.modal.left_panel.tenzu_sad_aria_description')"
          ></mat-icon>
        }
      </div>
      <h1 class="mat-headline-medium text-tertiary text-center">
        {{ t("portal.modal.left_panel.title") }}
      </h1>
      <p class="mat-body-medium">
        {{ t("portal.modal.left_panel.text") }}
      </p>
    </ng-container>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PortalLeftPanelComponent {
  priceAmount = input<number>();
  iconRegistry = inject(MatIconRegistry);
  sanitizer = inject(DomSanitizer);
  constructor() {
    this.iconRegistry.addSvgIcon(
      "heart-animated",
      this.sanitizer.bypassSecurityTrustResourceUrl("tenzu_heart_animated.svg"),
    );
    this.iconRegistry.addSvgIcon(
      "sad-animated",
      this.sanitizer.bypassSecurityTrustResourceUrl("tenzu_sad_animated.svg"),
    );
  }
}
